import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-jjsv-tile',
  imports: [CommonModule],
  templateUrl: './jjsv-tile.component.html',
  styleUrl: './jjsv-tile.component.scss',
})
export class JjsvTile {
  @Input() orderType: string = '';
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() linkLabel: string = '';
  @Input() linkHref: string = '#';
  @Output() linkClick: EventEmitter<string> = new EventEmitter<string>();
  private _isBordered: boolean = false;
  
  @Input() 
  set isBordered(value: boolean | string) {
    // Coerce string values to boolean (handles "true"/"false" from backend)
    this._isBordered = value === true || value === 'true';
  }
  
  get isBordered(): boolean {
    return this._isBordered;
  }

  navigateToLink(event: Event): void {
    this.linkClick.emit(this.orderType);
  }
}
